import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar } from '@fullcalendar/core';

export function initCalCoordinators(cal: Calendar) {
  p('initCalCoordinators');

  const calendar = cal;

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default btn-sm margin-5px',
    html: '<i class="fa fa-user"></i> Koordinátorok'
  });
  $('#btnContainer').append(btn);

  const source = calendar.addEventSource({
    url: '/coordinators.json',
  });
  source.remove();

  let active = (Cookies.get('cal_coordinators') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.css('background-color', '#dfd9f2') : btn.css('background-color', 'white');
    active ? calendar.addEventSource(source) : source.remove();
    Cookies.set('cal_coordinators', active + '', {
      expires: 10,
      path: '/'
    });
  }

}